/** @module Apparel/_StyleWizardMixIn */
define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/Deferred",
	"csi/widget/LabeledImage",
], function(declare, csi, Deferred, LabeledImage) {

	const COLLECTION = "Collection";
	const SEASON = "ParentSeason";

	return declare(null, {
		/**@property {boolean} processHierarchyForm - set to false, won't handle the form any more, the parent class will take over */
		processHierarchyForm: true,

		/**@property {cnl} selectedCollectionUrl - the current selected Collection  */
		selectedCollectionUrl: null,

		/**@property {cnl} selectedSeasonUrl - the current selected Season  */
		selectedSeasonUrl: null,

		/**
		 * @override
		 *  determine disable the "Next" button or not
		 */
		disableNext: function(wizard, page, index) {
			if (index == 0 && page.viewTab.defView.getType() == "Form") {
				return !page.viewTab.canProceed;
			}

			return this.inherited(arguments);
		},

		/**
		 *@override
		 * Prepare the data and pass it into the next page
		 */
		onNextPage: function(wizard, currentPage, nextPage, bFinish) {
			if (bFinish) {
				return null;
			}
			// backup the Collection, cover the case where user keep hitting "Save & New", then hit "finish" button at the last time
			const {m_cache, m_formData, selectedSeasonUrl} = this;
			let dfd;

			if (wizard.getIndexOfPage(nextPage) == 1) {
				this.selectedCollectionUrl = m_formData.getFieldValue(COLLECTION);
				this.selectedSeasonUrl = m_formData.getFieldValue(SEASON);

				// for the style form, update the form context(hierarchy information) so that the expression works properly
				dfd = m_cache.getNodeDeferred(this.selectedCollectionUrl).then((node) => {
					m_formData.setParent(node);
				});

				// if season changed and view already exists, then refresh Theme/Shape fields
				if (selectedSeasonUrl !== this.selectedSeasonUrl) {
					const {viewTab} = nextPage;
					viewTab?.resetFieldStoreAndValue("Shape", csi.EMPTY_URL);
					viewTab?.resetFieldStoreAndValue("Theme", csi.EMPTY_URL);
				}
			} else {
				dfd = new Deferred().resolve();
			}

			// don't refresh the page, otherwise, the fields carry over from the first page may be gone in the case where you switch between pages
			return dfd.then(() => wizard.setFormDataToPage(nextPage, m_formData, false));
		},

		/**
		 *@override
		 * Preselect the hierarchy Fields
		 */
		onWizardViewCreate: function(wizard, page, view) {
			var index = wizard.getIndexOfPage(page);

			if (index == 0) {
				const hierarchyNode = this.widget.getViewNode();
				const collectionNode = this.getCache().getNode(this.selectedCollectionUrl);

				view.populateHierarchyField(hierarchyNode, collectionNode);
			}

			if (this.imageUrl) {
				wizard.rightWidgetProperties = {
					imageSrc: this.imageUrl,
				}
				wizard.rightWidgetClass = LabeledImage;
			}
		},

		/** @override
		 * Set the productSourceCreationLevel to the viewParams from NewStyleFromSupplierRequestWizard
		 */
		onWizardViewPreCreate: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*csi.view.Widget*/view, viewParams) {
			viewParams.productSourceCreationLevel = this.productSourceCreationLevel;
		},

		/**
		 *@override
		 * Issue request
		 */
		process: function() {
			// specify the parent url so that the parent node can be handled on the server side as expected
			if (this.processHierarchyForm) {
				const fd = this.m_formData;

				// in the case of "Save & New", the formData would be reset, so use the backup one
				this.m_urlParent = fd.getFieldValue(COLLECTION, true) || this.selectedCollectionUrl;
				this._ignoreUnnecessaryFieldValues();
			}

			this.inherited(arguments);
		},

		/**
		 * Ignore the unnecessary Fields value
		 */
		_ignoreUnnecessaryFieldValues: function() {
			const fd = this.m_formData;
			fd.getFieldValue("Category1", true);
			fd.getFieldValue("Category2", true);
			fd.getFieldValue("ParentSeason", true);
		}
	});
});
